<template>
  <modal id="milestone-modal" :size="`lg`" :show-footer="false">
    <template v-slot:title> New Authoring Milestone Achievement </template>
    <template v-slot:body>
      <div class="row mb-50">
        <div class="co-md-12 mt-10 text-center">
          <img
            src="/capsiminbox/images/IAP-Dashboard_Iconcheck_large.svg"
            alt="check mark icon"
            width="100"
            height="100"
          />
        </div>
        <div class="col-md-10 col-md-offset-1 text-center">
          <h3>
            <strong>{{ message }}</strong>
          </h3>
          <p>
            {{ tooltipDesc }}
          </p>
        </div>
      </div>
    </template>
  </modal>
</template>
<script>
  export default {
    name: 'MilestoneModal',
    props: {
      message: {
        type: String,
        required: true,
        default: '',
      },
      tooltipDesc: {
        type: String,
        required: true,
        default: '',
      },
    },
  };
</script>
